import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Zap, Shield, Truck, Flame } from "lucide-react";
import StoreLayout from "../components/StoreLayout";
import CultMarquee from "../components/CultMarquee";
import ProductCard from "../components/ProductCard";
import { api } from "../lib/api";

const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_f80e39fa-3ab4-4fff-9ec3-40cb3c2b407a/artifacts/j5jurx70_ChatGPT%20Image%20May%2023%2C%202026%2C%2012_14_44%20PM.png";
const LOOKBOOK = "https://images.unsplash.com/photo-1761073490980-ecd40e9bec57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxzdHJlZXR3ZWFyJTIwZmFzaGlvbiUyMG1vZGVsJTIwbmVvbiUyMGRhcmslMjB1cmJhbnxlbnwwfHx8fDE3Nzk1MTk0Njd8MA&ixlib=rb-4.1.0&q=85";
const LOOKBOOK2 = "https://images.unsplash.com/photo-1761084688828-c53ddc918307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxzdHJlZXR3ZWFyJTIwZmFzaGlvbiUyMG1vZGVsJTIwbmVvbiUyMGRhcmslMjB1cmJhbnxlbnwwfHx8fDE3Nzk1MTk0Njd8MA&ixlib=rb-4.1.0&q=85";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [hot, setHot] = useState([]);

  useEffect(() => {
    api.get("/products").then((res) => setProducts(res.data)).catch(() => {});
    api.get("/products-hot?limit=4").then((res) => setHot(res.data || [])).catch(() => {});
  }, []);

  const featured = products.filter((p) => p.featured).slice(0, 4);
  const drop = products.filter((p) => p.collection === "drop-01").slice(0, 4);

  return (
    <StoreLayout>
      {/* HERO */}
      <section className="relative min-h-[88vh] flex items-end overflow-hidden border-b border-[#27272A]" data-testid="hero-section">
        <div
          className="absolute inset-0 bg-cover bg-center grain"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.85) 100%), url(${LOOKBOOK2})`,
          }}
        />
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pb-16 pt-32 w-full">
          <div className="grid md:grid-cols-12 gap-6 items-end">
            <div className="md:col-span-8">
              <p className="label-mono text-[#CFF048] mb-6">DROP 01 // EST. 2026 // LIVE</p>
              <h1 className="hero-title text-[14vw] md:text-[10vw] uppercase">
                Live<br />
                <span className="text-[#CFF048]">Different.</span><br />
                Stay Cult.
              </h1>
              <p className="font-body text-[#A1A1AA] max-w-md mt-6 text-base">
                Heavyweight cotton. Neon graffiti prints. Limited drops. Not a trend — it&apos;s a Lyf.
              </p>
              <div className="flex flex-wrap gap-4 mt-8">
                <Link to="/shop" className="btn-neon" data-testid="hero-shop-btn">
                  SHOP THE DROP <ArrowRight size={18} />
                </Link>
                <Link to="/shop?collection=limited" className="btn-outline" data-testid="hero-limited-btn">
                  LIMITED // 50 PCS
                </Link>
              </div>
            </div>
            <div className="md:col-span-4 hidden md:flex justify-end">
              <img src={LOGO_WHITE} alt="cult lyf logo" className="w-56 opacity-90" />
            </div>
          </div>
        </div>
      </section>

      <CultMarquee />

      {/* FEATURED GRID */}
      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-20" data-testid="featured-section">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="label-mono text-[#71717A]">// 01 LATEST DROPS</p>
            <h2 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tight mt-2">The Drop</h2>
          </div>
          <Link to="/shop" className="label-mono text-[#CFF048] hover:underline" data-testid="see-all-link">
            SEE ALL →
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map((p, i) => (
            <div key={p.id} className="fade-up" style={{ animationDelay: `${i * 80}ms` }}>
              <ProductCard p={p} />
            </div>
          ))}
        </div>
      </section>

      {/* HOT SELLING */}
      {hot.length > 0 && (
        <section
          className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-20 border-t border-[#27272A]"
          data-testid="hot-selling-section"
        >
          <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
            <div>
              <p className="label-mono text-[#71717A] flex items-center gap-2">
                <Flame size={14} className="text-[#CFF048]" /> // 02 · HOT SELLING
              </p>
              <h2 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tight mt-2">
                Flying off <span className="text-[#CFF048]">the rack.</span>
              </h2>
              <p className="label-mono text-[#71717A] mt-3">// THE CULT IS WEARING THESE THE MOST</p>
            </div>
            <Link to="/shop" className="label-mono text-[#CFF048] hover:underline">
              SEE ALL →
            </Link>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {hot.map((p, i) => (
              <div key={p.id} className="fade-up relative" style={{ animationDelay: `${i * 80}ms` }}>
                <div className="absolute top-3 left-3 z-10 bg-[#CFF048] text-black px-2 py-1 label-mono text-[10px] flex items-center gap-1 pointer-events-none">
                  <Flame size={11} /> HOT · #{i + 1}
                </div>
                <ProductCard p={p} />
              </div>
            ))}
          </div>
        </section>
      )}

      {/* LOOKBOOK SPLIT */}
      <section className="border-y border-[#27272A]">
        <div className="grid md:grid-cols-2">
          <div className="relative h-[60vh] md:h-[80vh] overflow-hidden">
            <img src={LOOKBOOK} alt="lookbook" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
            <div className="absolute bottom-8 left-8 right-8">
              <p className="label-mono text-[#CFF048] mb-3">// LOOKBOOK</p>
              <h3 className="font-display font-black text-3xl md:text-5xl uppercase leading-none">Cult of<br/>The Streets</h3>
            </div>
          </div>
          <div className="bg-[#0A0A0A] flex items-center p-10 md:p-16">
            <div>
              <p className="label-mono text-[#71717A] mb-4">// ABOUT</p>
              <h3 className="font-display font-black text-3xl md:text-5xl uppercase leading-none mb-6">
                Not a brand.<br/><span className="text-[#CFF048]">A movement.</span>
              </h3>
              <p className="text-[#A1A1AA] mb-8 max-w-md">
                Cult Lyf is built on raw expression. Heavyweight 240gsm tees, screen-printed by hand,
                drop-shipped from the underground. Each release is limited. Once it&apos;s gone, it&apos;s gone.
              </p>
              <div className="grid grid-cols-2 gap-6 max-w-md">
                <div className="border-l-2 border-[#CFF048] pl-3">
                  <Zap size={20} className="text-[#CFF048]" />
                  <p className="label-mono text-[#71717A] mt-2">FAST DROPS</p>
                  <p className="font-display font-bold text-sm mt-1">Weekly</p>
                </div>
                <div className="border-l-2 border-[#CFF048] pl-3">
                  <Shield size={20} className="text-[#CFF048]" />
                  <p className="label-mono text-[#71717A] mt-2">HEAVYWEIGHT</p>
                  <p className="font-display font-bold text-sm mt-1">240 GSM</p>
                </div>
                <div className="border-l-2 border-[#CFF048] pl-3">
                  <Truck size={20} className="text-[#CFF048]" />
                  <p className="label-mono text-[#71717A] mt-2">WORLDWIDE</p>
                  <p className="font-display font-bold text-sm mt-1">3-7 Days</p>
                </div>
                <div className="border-l-2 border-[#CFF048] pl-3">
                  <Sparkles size={20} className="text-[#CFF048]" />
                  <p className="label-mono text-[#71717A] mt-2">EST.</p>
                  <p className="font-display font-bold text-sm mt-1">2026</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CultMarquee inverted />

      {/* DROP 01 GRID */}
      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-20">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="label-mono text-[#71717A]">// 02 DROP 01 SERIES</p>
            <h2 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tight mt-2">Drop 01 // 2026</h2>
          </div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {drop.map((p, i) => (
            <div key={p.id} className="fade-up" style={{ animationDelay: `${i * 80}ms` }}>
              <ProductCard p={p} />
            </div>
          ))}
        </div>
      </section>
    </StoreLayout>
  );
}
